<template>
  <div class="content-first">
    <div class="content-second">
      <section class="first">
        <h1>Autorización Tratamiento de Datos Personales Empleados/as</h1>
        <p>
          Este formulario tiene como propósito renovar el consentimiento expreso
          que otorgaste al momento de suscribir tu contrato de trabajo y sus
          anexos, para que tu empleador pueda recopilar, tratar y hacer uso de
          tus datos personales en el marco de la relación laboral que los une.
        </p>
        <p>
          La transformación de nuestro negocio, que incluye la de tipo digital,
          implica el tratamiento de nuevas categorías de datos, otras formas de
          procesarlos y nuevas finalidades a las que son destinados, para
          cumplir adecuadamente nuestras obligaciones legales, contractuales y
          convencionales como empleadores, y poder garantizarte el acceso a los
          programas de bienestar y otros beneficios que ofrecen las compañías.
        </p>
        <p>
          Queremos estar seguros de que conoces quién es el responsable de este
          tratamiento en cada caso, qué datos procesa, cómo y para qué. Lee con
          atención las siguientes declaraciones y recuerda que la información
          que aquí consignes será utilizada como evidencia posterior de tu
          autorización.
        </p>
      </section>
      <section class="second">
        <p>
          Al marcar la casilla "AUTORIZO”, doy mi consentimiento expreso a
          BAVARIA Y CIA S.C.A., KOPPS COMMERCIAL S.A.S., ZX VENTURES COLOMBIA
          S.A.S., CERVECERIA DEL VALLE S.A.S., CERVECERIA UNION S.A., INDUSTRIA
          GRAFICA LATINOAMERICA S.A.S., TRANSPORTES TEV S.A.S. y/o CERVECERIA
          BBC DE LA SABANA S.A.S. (“Responsables del Tratamiento”), para que
          realice(n) el tratamiento de mis datos personales, de conformidad con
          las condiciones y finalidades que me han sido informadas en el
          siguiente Aviso de Privacidad para Empleados (<a
            href="https://anheuserbuschinbev.sharepoint.com/:b:/s/ECBUCO/EXJpKMgYpUxGojIjZrSEAyUB0iSqFQQ9lzHOqfBHFHZf_Q"
            >https://anheuserbuschinbev.sharepoint.com/:b:/s/ECBUCO/EXJpKMgYpUxGojIjZrSEAyUB0iSqFQQ9lzHOqfBHFHZf_Q</a
          >)
        </p>
        <p>
          Esta autorización cobija cualquier información personal que: A. Sea
          proporcionada directamente por mí al momento de suscribir el contrato
          de trabajo, llenar formularios de registro o actualización de datos
          del empleado, contestar encuestas, declarar conflictos de intereses,
          etc. B. Esté contenida en documentos de empleo, como el documento de
          identidad, los registros civiles, la hoja de vida y sus anexos, los
          formularios de afiliación al SSSI, las certificaciones bancarias,
          entre otros. C. Sea capturada por sistemas de videovigilancia, cámaras
          fotográficas, equipos de grabación de sonido, entre otros, como la
          imagen de mi rostro, mi voz o cualquier otra característica física que
          me identifique plenamente o me hagan identificable. D. Sea creada,
          observada o inferida a partir del uso de las herramientas tecnológicas
          suministradas por mi empleador para el desempeño de mis labores, como
          los equipos de cómputo, tabletas y teléfonos móviles, el correo
          electrónico, la red wi-fi, los sistemas operativos y softwares (ej.,
          Windows, SAP, Workday), las aplicaciones de comunicación y
          colaboración (ej., Teams, Zoom), entre otras.
        </p>
        <p>
          Como su representante legal, autorizo también el tratamiento de los
          datos personales que proporcione de mis hijos menores o incapaces.
          Entiendo que estos datos serán tratados bajo medidas de seguridad de
          la información reforzadas y bajo el principio de “necesidad estricta”,
          con respeto por sus derechos fundamentales y atendiendo siempre al
          interés superior de los niños, niñas y adolescentes.
        </p>
        <p>
          En caso de que proporcione información personal de terceros, como mi
          cónyuge o compañero(a) permanente y/o mis contactos de emergencia,
          confirmo que les informé para qué son requeridos sus datos por parte
          de mi empleador y las condiciones del tratamiento bajo su Política de
          Tratamiento de la Información, por lo que obtuve su consentimiento
          previo y explícito para suministrar su información personal a las
          Responsables del Tratamiento.
        </p>
        <div class="mb-4 content-checkbox">
          <b-form-checkbox v-model="formData.data_treatment" class="custom-checkbox-termins" size="lg"><p>AUTORIZO EL TRATAMIENTO DE DATOS PERSONALES</p></b-form-checkbox>
        </div>
        <p>
          Al marcar esta segunda casilla de autorización, confirmo que doy
          también mi consentimiento al tratamiento de los datos sensibles que
          proporcione voluntariamente para las finalidades informadas en el
          Aviso de Privacidad para Empleados (<a
            href="https://anheuserbuschinbev.sharepoint.com/:b:/s/ECBUCO/EXJpKMgYpUxGojIjZrSEAyUB0iSqFQQ9lzHOqfBHFHZf_Q"
            >https://anheuserbuschinbev.sharepoint.com/:b:/s/ECBUCO/EXJpKMgYpUxGojIjZrSEAyUB0iSqFQQ9lzHOqfBHFHZf_Q</a
          >) por ejemplo, pero sin limitarse a mi etnia, pertenencia a
          poblaciones vulnerables, orientación sexual, afiliación a sindicatos,
          datos biométricos (ej., huella dactilar), entre otros.
        </p>
        <p>
          Confirmo que he sido informado sobre el carácter opcional que tienen
          las preguntas o campos en los formularios que versen sobre estos datos
          sensibles.
        </p>
        <div class="mb-5 content-checkbox">
          <b-form-checkbox v-model="formData.privacy_policy" class="custom-checkbox-termins" size="lg"><p>AUTORIZO EL TRATAMIENTO DE DATOS SENSIBLES</p></b-form-checkbox>
        </div>
        <button class="btn-accept" :disabled="!isDisabled || isLoading" @click.prevent="submit">
          <b-spinner v-if="isLoading" />
          <span v-else>Enviar</span>
        </button>
        <b-alert
          :show="isError"
          variant="danger"
          class="mt-4 pb-0"
        >
          <p>Error en el servidor. Intente nuevamente</p>
        </b-alert>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ApiPermisos from "@/services/apiPermisos";
import { clear, get } from '@/common/helps/local-storage';

export default {
  name: "terminsandcondition",
  data() {
    return {
      formData: {
        privacy_policy: false,
        data_treatment: false
      },
      isLoading: false,
      isError: false
    }
  },
  computed: {
    ...mapState("modCore", ["user"]),
    isDisabled() {
      return this.formData.privacy_policy && this.formData.data_treatment
    }
  },
  methods: {
    async submit() {
      const me = this;
      me.isError = false;
      me.isLoading = true;

      try {
        const response = await ApiPermisos.updatedTerminsAndConditons(me.user.id, me.formData);
        if (!response.error) {
          clear();
          me.$router.push({ path: "/auth" });
        }
      } catch {
        me.isError = true;
      } finally {
        me.isLoading = false;
      }
    }
  },
  mounted() {
    const me = this;
    if (!get('user')) me.$router.push({ path: "/auth" });
    if (me.user.privacy_policy) me.$router.push({ path: "/" });
  }
};
</script>

<style lang="css">
.content-first {
  background-color: #d9d9d9;
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
}
.content-second {
  width: 600px;
  margin: 57px 194px 57px 194px;
  background-color: #ffffff;
}
.content-second .first {
  background-color: #e42e2e;
  color: #ffffff;
  padding: 48px 32px 10px 32px;
}

.content-second .second {
  background-color: #ffffff;
  color: #000000;
  padding: 40px 32px 48px 32px;
}

.content-second p {
  font-size: 14px;
  font-weight: 400;
  line-height: 22px !important;
  text-align: left;
}

.content-second p a {
  word-wrap: break-word !important;
}
.content-second .first h1 {
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  line-height: 19.36px;
  margin-bottom: 20px;
}

.content-checkbox {
  padding-bottom: 12px;
  padding-top: 12px;
}

.content-checkbox p {
  margin-bottom: 0 !important;
  font-size: 16px !important;
  margin-left: 8px !important;
}

.custom-checkbox-termins .custom-control-label::before {
  top: 0 !important;
  left: -1.875rem !important;
  width: 2rem !important;
  height: 2rem !important;
  border-radius: 50% !important;
}

.custom-checkbox-termins .custom-control-label::after {
  top: 0 !important;
  left: -1.875rem !important;
  width: 2rem !important;
  height: 2rem !important;
  background-size: 50% 50% !important;
}
.btn-accept {
  background-color: #5D5FEF;
  color: #ffffff;
  font-size: 18px;
  border-radius: 20px;
  width: 100px;
  height: 40px;
  border: none;
}
</style>
